import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "@pages/login/controller/login-slice";
import logoutReducer from "@pages/login/controller/logout-slice";
import countryReducer from "@pages/country/controller/country-slice";
import stateReducer from "@pages/state/controller/state-slice";
import genreReducer from "@pages/genre/controller/genre-slice";
import bannerReducer from "@pages/banner/controller/banner-slice";
import feedbackReducer from "@pages/feedback/controller/feedback-slice";
import districtReducer from "@pages/district/controller/district-slice";
import membershipReducer from "@pages/membership/controller/membership-slice";
import authorReducer from "@pages/author/controller/author-slice";
import roleReducer from "@pages/roles/controller/role-slice";
import mediaReducer from "@pages/media/controller/media-slice";
import postReducer from "@pages/post/controller/post-slice";
import contentReducer from "@pages/content-units/controller/content-slice";
import publishReducer from "@pages/publish/controller/publish.slice"; //WRONGLY RETURN
import userReducer from "@pages/users/controller/user-slice";
import authReducer from "@authguard/auth-slice";
import profileReducer from "@components/profile/controller/profile-slice";
import voiceReducer from "@pages/voices/controller/voice-slice";
import deleteReducer from "@helpers/custom-delete/controller/delete-slice";
import paymentReducer from "@pages/purchase-log/controller/payment-slice";
import dashboardReducer from "@pages/dashboard/controller/dashboard-slice";
import permissionReducer from "@pages/permissions/controller/permission-slice";
import customerFeedbackReducer from "@pages/customer-feedback-log/controller/customer-feedback-slice";

export const store = configureStore({
  reducer: {
    login: loginReducer,
    logout: logoutReducer,
    auth: authReducer,
    country: countryReducer,
    profile: profileReducer,
    state: stateReducer,
    role: roleReducer,
    genre: genreReducer,
    delete: deleteReducer,
    feedback: feedbackReducer,
    district: districtReducer,
    voice: voiceReducer,
    banner: bannerReducer,
    author: authorReducer,
    membership: membershipReducer,
    media: mediaReducer,
    post: postReducer,
    publish: publishReducer,
    content: contentReducer,
    user: userReducer,
    payment: paymentReducer,
    dashboard: dashboardReducer,
    permission: permissionReducer,
    customerFeedback: customerFeedbackReducer,
    // forgotPassword: forgotPasswordReducer,
    // department: departmentloginReducer,
    // employee: employeeReducer,
    // customer: customerReducer,
    // role: roleReducer,
    // vertical: verticalReducer,
    // project: projectReducer
  },
});
